var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:['Btn', {'with-icon': _vm.icon}],attrs:{"href":_vm.href,"target":_vm.target,"type":_vm.type}},[_vm._t("default"),_vm._v(" "),(_vm.icon)?_c('icon',{staticClass:"btn-icon",attrs:{"name":_vm.icon}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }